import { useIntl } from 'react-intl';
import LucideIcon from 'src/componentes/lucide-icon';
import ContentManager from 'src/componentes/content-manager';
import ReactTooltip from 'react-tooltip';
import Confirm from 'src/componentes/message-box/confirm';

import Edit from './edit';

const Recorrencia = ({
  handleChangeRecorrencia,
  isDisabled,
  recorrencia,
  ehMaisDeUmDia,
}) => {
  const intl = useIntl();
  const isEmpty = !recorrencia?.periodicidadeRecorrencia;

  const handleOpenConfiguration = () => {
    ContentManager.addContent(
      <Edit
        recorrencia={recorrencia}
        isEdit={!isEmpty}
        isDisabled={isDisabled}
        handleChangeRecorrencia={handleChangeRecorrencia}
        ehMaisDeUmDia={ehMaisDeUmDia}
      />
    );
  };

  const handleClearRecorrencia = () => {
    handleChangeRecorrencia({});
  };

  const renderDeleteConfirm = () => {
    ContentManager.addContent(
      <Confirm
        message={intl.formatMessage({
          id: 'label.desejaMesmoExcluirARecorrencia',
        })}
        handleConfirm={handleClearRecorrencia}
      />
    );
  };

  return (
    <>
      <div>
        <div className="d-flex align-items-center mt-1 mb-3">
          <LucideIcon icon="Repeat" className="mr-2 text-primary" size={20} />
          <a
            className="text-primary text-sm font-weight-bolder mr-2"
            onClick={() => handleOpenConfiguration()}
            style={{ cursor: 'pointer' }}
          >
            {isEmpty
              ? intl.formatMessage({ id: 'recorrencia' })
              : intl.formatMessage({ id: 'editarRecorrencia' })}
          </a>
          <span style={{ marginLeft: 20 }} className="text-primary">
            {recorrencia?.occurrenceText}{' '}
            {recorrencia?.dataTerminoRecorrencia?.toLocaleDateString()}
            {!isEmpty && (
              <>
                <LucideIcon
                  style={{ marginLeft: 20 }}
                  icon="X"
                  className="mr-2 text-primary cursor-pointer"
                  size={16}
                  onClick={renderDeleteConfirm}
                  id="limpaRecorrenciaHint"
                  data-tip
                  data-for="limpaRecorrenciaHint"
                />
                <ReactTooltip
                  id="limpaRecorrenciaHint"
                  place="right"
                  aria-haspopup="true"
                >
                  <div
                    style={{
                      maxWidth: 200,
                      textAlign: 'center',
                    }}
                  >
                    {intl.formatMessage({ id: 'label.limparRecorrencia' })}
                  </div>
                </ReactTooltip>
              </>
            )}
          </span>
        </div>
      </div>
    </>
  );
};

export default Recorrencia;
